import { Pipe, PipeTransform } from '@angular/core';
import { User } from '../../models/security/user';

@Pipe({
	name: 'filterUserByName'
})
export class FilterUserByNamePipe implements PipeTransform {
	transform(user: User[], filter: string): User[] {
		if (
			!user ||
			!filter ||
			user === null ||
			filter === null ||
			filter === ''
		) {
			return user;
		}

		return user.filter((user: User) => {
			if (user.lastName && user.firstName) {
				// TODO: add lastName too
				return user.lastName.toLowerCase().includes(filter.toLowerCase()) || 
				user.firstName.toLowerCase().includes(filter.toLowerCase());
			}
			return false;
		});
	}
}
